/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{AnimationFeature as i}from"./animation/index.js";import{ExitAnimationFeature as t}from"./animation/exit.js";const o={animation:{Feature:i},exit:{Feature:t}};export{o as animations};
//# sourceMappingURL=animations.js.map
